

<ng-container *ngIf="!template">
  <i class="fa fa fa-clock-o mr-1"></i>
  <span class="fw-semibold">{{ time + ' seconds' }}</span>
</ng-container>

<ng-container *ngIf="template">
  <ng-container *ngTemplateOutlet="template; context: { $implicit: time }"></ng-container>
</ng-container>



